const ConstantsImages = {
  ACCOUNT_IMAGE: "/assets/images/account_image.svg", // 2.1rem x 2rem
  ADD_IMAGE: "/assets/images/add_image.svg", // 1.3rem x 1.4rem
  ALERT_IMAGE: "/assets/images/alert_image.svg", // 1.7rem x 1.5rem
  APPROVE_IMAGE: "/assets/images/approve_image.svg", // 3.1rem x 3.2rem
  ARROW_IMAGE: "/assets/images/arrow_image.svg", // 1.8rem x 1.8rem
  ARROW_LEFT_IMAGE: "/assets/images/arrow_left_image.svg", // 2rem x 0.9rem
  ARROW_SMALL_IMAGE: "/assets/images/arrow_small_image.svg", // 1.1rem x 0.7rem
  ARROW_WHITE_IMAGE: "/assets/images/arrow_white_image.svg", // 1.1rem x 0.6rem
  BACK_IMAGE: "/assets/images/back_image.svg", // 1.6rem x 1.1rem
  BELL_IMAGE: "/assets/images/bell_image.svg", // 1.8rem x 1.8rem
  BUS_IMAGE: "/assets/images/bus_image.svg", // 2.1rem x 1.4rem
  BUS_PARKING_IMAGE: "/assets/images/bus_parking_image.svg", // 3rem x 3rem
  BUS_PARKING_TWO_IMAGE: "/assets/images/bus_parking_two_image.svg", // 3rem x 3rem
  BUS_ROUTE_IMAGE: "/assets/images/bus_route_image.svg", // 1.8rem x 1.8rem
  BUS_STATION_IMAGE: "/assets/images/bus_station_image.svg", // 7.7rem x 6.5rem
  CAR_IMAGE: "/assets/images/car_image.svg", // 2.0rem x 1.5rem
  CHANGED_COLUMN_IMAGE: "/assets/images/changed_column_image.svg", // 1.2rem x 1.2rem
  CHANGELOG_IMAGE: "/assets/images/changelog_image.svg", // 2.1rem x 2.4rem
  CHECKMARK_IMAGE: "/assets/images/checkmark_image.svg", // 1.2rem x 1rem
  CHECK_WHITE_2_IMAGE: "/assets/images/check_white_2_image.svg", // 0.9rem x 0.8rem
  CHECK_WHITE_IMAGE: "/assets/images/check_white_image.svg", // 1.7rem x 1.2rem
  CLOSE_2_IMAGE: "/assets/images/close_2_image.svg", // 1rem x 1.1rem
  CLOSE_3_IMAGE: "/assets/images/close_3_image.svg", // 1.1rem x 1.1rem
  CLOSE_4_IMAGE: "/assets/images/close_4_image.svg", // 1.1rem x 1.2rem
  CLOSE_5_IMAGE: "/assets/images/close_5_image.svg", // 1.1rem x 1.2rem
  CLOSE_CHANGELOG_IMAGE: "/assets/images/close_changelog_image.svg", // 1.1rem x 1.2rem
  PENDING_REQUESTS_CLOSE_IMAGE: "/assets/images/pending_requests_close_image.svg", // 1rem x 1rem
  COINS_IMAGE: "/assets/images/coins_image.svg", // 2.7rem x 2.9rem
  COINS_TWO_IMAGE: "/assets/images/coins_two_image.svg", // 1.8rem x 1.9rem
  COMMENTS_IMAGE: "/assets/images/comments_image.svg", // 1.6rem x 1.6rem
  COMPARISON_MODE_IMAGE: "/assets/images/comparison_mode_image.svg", // 1.9rem x 1.8rem
  CONE_IMAGE: "/assets/images/cone_image.svg", // 2.3rem x 2.1rem
  DATE_TIME_IMAGE: "/assets/images/date_time_image.svg", // 1.2rem x 1.5rem
  UPDATES_LIST_DATE_IMAGE: "/assets/images/updates_list_date_icon.svg", // 1.9rem x 1.35rem
  UPDATES_LIST_PERSON_IMAGE: "/assets/images/updates_list_person_icon.svg", // 1.9rem x 1.25rem
  UPDATES_LIST_COLUMN_IMAGE: "/assets/images/updates_list_column_icon.svg", // 1.76rem x 1.05rem
  UPDATES_LIST_ARROW_IMAGE: "/assets/images/updates_list_arrow_icon.svg", // 2rem x 0.8rem
  DELETE_2_IMAGE: "/assets/images/delete_2_image.svg", // 1.7rem x 1.8rem
  DELETE_IMAGE: "/assets/images/delete_image.svg", // 1.8rem x 2.1rem
  EDIT_IMAGE: "/assets/images/edit_image.svg", // 2.4rem x 2.3rem
  FREEZE_VERSION_IMAGE: "/assets/images/freeze_version_image.svg", // 1.3rem x 1.3rem
  FREEZE_DIALOG_CLOSE_IMAGE: "/assets/images/freeze_dialog_close_image.svg", // 1rem x 1rem
  FREEZE_DIALOG_ILLUSTRATION_IMAGE: "/assets/images/freeze_dialog_illustration_image.svg", // 7.1rem x 7.2rem
  FREEZE_SUCCESS_ILLUSTRATION_IMAGE: "/assets/images/freeze_success_illustration_image.svg", // 7.1rem x 7.2rem
  FROZEN_VERSION_BADGE_IMAGE: "/assets/images/frozen_version_badge_image.svg", // 1.9rem x 1.9rem
  GAUGE_1_IMAGE: "/assets/images/gauge_1_image.svg", // 4.9rem x 3rem
  GAUGE_2_IMAGE: "/assets/images/gauge_2_image.svg", // 4.9rem x 3rem
  GAUGE_3_IMAGE: "/assets/images/gauge_3_image.svg", // 4.9rem x 3.2rem
  GAUGE_4_IMAGE: "/assets/images/gauge_4_image.svg", // 4.9rem x 3rem
  GAUGE_5_IMAGE: "/assets/images/gauge_5_image.svg", // 4.9rem x 3rem
  GAUGE_EMPTY_IMAGE: "/assets/images/gauge_empty_image.svg", // 4.9rem x 3rem
  GREEN_ARROW_IMAGE: "/assets/images/green_arrow_image.svg", // 1.2rem x 3.3rem
  LAST_UPDATED_IMAGE: "/assets/images/last_updated_image.svg", // 1.6rem x 2.1rem
  LEFT_ARROW_IMAGE: "/assets/images/left_arrow_image.svg", // 1.7rem x 1.1rem
  LINES_IMAGE: "/assets/images/lines_image.svg", // 4rem x 2.9rem
  MARKER_2_IMAGE: "/assets/images/marker_2_image.svg", // 1.2rem x 1.4rem
  MARKER_IMAGE: "/assets/images/marker_image.svg", // 1.2rem x 1.4rem
  MODEL_IMAGE: "/assets/images/model_image.svg", // 1.7rem x 1.6rem
  MODEL_VERSION_IMAGE: "/assets/images/model_version_image.svg", // 2rem x 2.1rem
  NOTE_IMAGE: "/assets/images/note_image.svg", // 6.4rem x 6.7rem
  ORGANIZATION_IMAGE: "/assets/images/organization_image.svg", // 1.6rem x 1.9rem
  PENCIL_CANCEL_IMAGE: "/assets/images/pencil_cancel_image.svg", // 1.6rem x 1.6rem
  PENCIL_IMAGE: "/assets/images/pencil_image.svg", // 1.7rem x 1.6rem
  PERSON_IMAGE: "/assets/images/person_image.svg", // 1.3rem x 1.4rem
  PLUS_BLUE_IMAGE: "/assets/images/plus_blue_image.svg", // 1.4rem x 1.5rem
  PLUS_WHITE_IMAGE: "/assets/images/plus_white_image.svg", // 1.3rem x 1.3rem
  POLYGON_IMAGE: "/assets/images/polygon_image.svg", // 1.7rem x 1.6rem
  REQUEST_DETAILS_IMAGE: "/assets/images/request_details_image.svg", // 2rem x 2rem
  CHANGE_REQUEST_ARROW_IMAGE: "/assets/images/change_request_arrow_image.svg", // 1.8rem x 0.6rem
  CHANGE_REQUEST_APPROVE_IMAGE: "/assets/images/change_request_approve_image.svg", // 1.8rem x 1.8rem
  CHANGE_REQUEST_REJECT_IMAGE: "/assets/images/change_request_reject_image.svg", // 1.8rem x 1.8rem
  CHANGE_REQUEST_APPROVED_CHECK_IMAGE: "/assets/images/change_request_approved_check_image.svg", // 2.7rem x 2.7rem
  CHANGE_REQUEST_REJECTED_ICON_IMAGE: "/assets/images/change_request_rejected_icon_image.svg", // 2.8rem x 2.8rem
  RED_ARROW_IMAGE: "/assets/images/red_arrow_image.svg", // 1.2rem x 3.3rem
  SEARCH_BLACK_IMAGE: "/assets/images/search_black_image.svg", // 1.7rem x 1.7rem
  SEARCH_IMAGE: "/assets/images/search_image.svg", // 1.6rem x 1.6rem
  SECTION_HEADER_IMAGE: "/assets/images/section_header_image.svg", // 2.1rem x 2.1rem
  SETTINGS_BLUE_IMAGE: "/assets/images/settings_blue_image.svg", // 1.7rem x 1.7rem
  SETTINGS_IMAGE: "/assets/images/settings_image.svg", // 1.7rem x 1.7rem
  TERMINAL_SCORE_PERSON_IMAGE: "/assets/images/terminal_score_person_image.svg", // 1.3rem x 1.3rem
  TERMINAL_RANK_GRAY_IMAGE: "/assets/images/terminal_rank_gray_image.svg", // 5.8rem x 5.8rem
  TERMINAL_RANK_IMAGE: "/assets/images/terminal_rank_image.svg", // 5.8rem x 5.8rem
  TERMINAL_STATUS_IMAGE: "/assets/images/terminal_status_image.svg", // 2.2rem x 1.2rem
  TERMINAL_TYPE_IMAGE: "/assets/images/terminal_type_image.svg", // 1.5rem x 1.4rem
  TOOLTIP_2_IMAGE: "/assets/images/tooltip_2_image.svg", // 1.3rem x 1.2rem
  TOOLTIP_IMAGE: "/assets/images/tooltip_image.svg", // 1.4rem x 1.4rem
  TRANSPORTATION_IMAGE: "/assets/images/transportation_image.svg", // 8.5rem x 17.2rem
  TRANSPORTATION_SMALL_IMAGE: "/assets/images/transportation_small_image.svg", // 5.2rem x 9.8rem
  VERTICAL_DOTS_IMAGE: "/assets/images/vertical_dots_image.svg", // 0.4rem x 3.3rem
  WHITE_ARROW_IMAGE: "/assets/images/white_arrow_image.svg", // 2.5rem x 1.2rem
  XLS_IMAGE: "/assets/images/xls_image.svg", // 4.6rem x 6.2rem
};

export default ConstantsImages;
